import React, { Component } from 'react';

const ICON_OPTIONS = [
    'fas fa-utensils','fas fa-hot-tub','fas fa-wifi','fas fa-train','fas fa-shopping-bag','fas fa-camera',
    'fas fa-swimmer','fas fa-dumbbell','fas fa-plane','fas fa-umbrella-beach','fas fa-mountain','fas fa-tree',
    'fas fa-snowflake','fas fa-sun','fas fa-coffee','fas fa-wine-glass','fas fa-bed','fas fa-bath',
    'fas fa-spa','fas fa-cocktail','fas fa-fish','fas fa-bowl-rice','fas fa-bus','fas fa-car',
    'fas fa-ship','fas fa-leaf','fas fa-fire','fas fa-gift','fas fa-glass-cheers','fas fa-ice-cream'
];

export class IconMaster extends Component {
    state = { items: [], loading: true, editing: null };

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/programplus/icons/master')
            .then(r => r.json())
            .then(j => this.setState({ items: j, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    save(e) {
        e.preventDefault();
        var ed = this.state.editing;
        if (!ed.name) { alert('กรุณากรอกชื่อ'); return; }
        fetch('api/programplus/icons/master', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(ed)
        }).then(r => {
            if (r.ok) { this.setState({ editing: null }); this.load(); }
        });
    }

    del(item) {
        if (!window.confirm('ลบ "' + item.name + '" ?')) return;
        fetch('api/programplus/icons/master/' + item.id, { method: 'DELETE' })
            .then(r => { if (r.ok) this.load(); });
    }

    render() {
        const { items, loading, editing } = this.state;
        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {items.length} รายการ</p>
                    <button className="btn btn-danger" onClick={() => this.setState({ editing: { id: 0, name: '', iconClass: 'fas fa-circle' } })}>
                        <i className="fas fa-plus"></i> เพิ่ม Icon
                    </button>
                </div>

                {editing && (
                    <form onSubmit={e => this.save(e)} className="card mb-3">
                        <div className="card-header"><strong>{editing.id === 0 ? 'เพิ่ม' : 'แก้ไข'} Icon</strong></div>
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <label className="form-label fw-bold">Icon Class</label>
                                    <select className="form-control" style={{color:'#333'}} value={editing.iconClass}
                                        onChange={e => this.setState({ editing: {...editing, iconClass: e.target.value} })}>
                                        {ICON_OPTIONS.map(ic => <option key={ic} value={ic} style={{color:'#333'}}>{ic}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-1 text-center pt-4">
                                    <span style={{ width: 40, height: 40, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                                        <i className={editing.iconClass}></i>
                                    </span>
                                </div>
                                <div className="col-md-8">
                                    <label className="form-label fw-bold">ชื่อ</label>
                                    <input type="text" className="form-control" value={editing.name} autoFocus
                                        onChange={e => this.setState({ editing: {...editing, name: e.target.value} })} placeholder="เช่น ออนเซ็น, FREE WIFI HOTEL"/>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end" style={{gap:8}}>
                                <button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({ editing: null })}>ยกเลิก</button>
                                <button type="submit" className="btn btn-success"><i className="fas fa-save"></i> บันทึก</button>
                            </div>
                        </div>
                    </form>
                )}

                {loading ? <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                : (
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ width: 60 }}>#</th>
                                    <th style={{ width: 60, textAlign: 'center' }}>Icon</th>
                                    <th>ชื่อ</th>
                                    <th style={{ width: 200 }}>Class</th>
                                    <th style={{ width: 120, textAlign: 'center' }}>จัดการ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((it, i) => (
                                    <tr key={it.id}>
                                        <td style={{ color: '#aaa' }}>{i + 1}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <span style={{ width: 32, height: 32, borderRadius: '50%', background: '#dc3545', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <i className={it.iconClass}></i>
                                            </span>
                                        </td>
                                        <td>{it.name}</td>
                                        <td><code style={{ fontSize: 11 }}>{it.iconClass}</code></td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button className="btn btn-outline-primary btn-sm me-1" style={{ marginRight: 4 }}
                                                onClick={() => this.setState({ editing: {...it} })}><i className="fas fa-edit"></i></button>
                                            <button className="btn btn-outline-danger btn-sm" onClick={() => this.del(it)}><i className="fas fa-trash"></i></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}
